import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState } from 'react';
import { usePopper as useReactPopper } from 'react-popper';
export var usePopper = function usePopper(panelRef, triggerRef) {
  var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'bottom';
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [0, 10];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      arrowRef = _useState2[0],
      setArrowRef = _useState2[1];

  var _useReactPopper = useReactPopper(triggerRef.current, panelRef.current, {
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowRef
      }
    }, {
      name: 'offset',
      options: {
        offset: offset
      }
    }],
    placement: align
  }),
      styles = _useReactPopper.styles,
      attributes = _useReactPopper.attributes;

  return {
    panelProps: _objectSpread({
      style: styles.popper
    }, attributes.popper),
    arrowProps: {
      ref: setArrowRef,
      style: styles.arrow
    }
  };
};